import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ isAuthenticated, children }) => {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const validarToken = async () => {
            const token = localStorage.getItem('token');
            if (!token) {
                setLoading(false);
                return;
            }

            try {
                const res = await fetch(`${process.env.REACT_APP_API_URL || "https://api.clelton-churrasqueiras.site"}/auth/validate`, {
                    headers: { Authorization: `Bearer ${token}` }
                });

                if (res.ok) {
                    setLoading(false); // Continua carregando a rota protegida
                } else {
                    localStorage.removeItem('token');
                    setLoading(false);
                }
            } catch (err) {
                localStorage.removeItem('token');
                setLoading(false);
            }
        };

        validarToken();
    }, []); // O efeito roda apenas uma vez, no momento em que a rota for acessada

    if (loading) {
        return <div>Loading...</div>; // Enquanto o token está sendo validado, exibimos uma tela de carregamento
    }

    if (!isAuthenticated) {
        return <Navigate to="/" />; // Redireciona para o login se o token não for válido
    }

    return children; // Se o token for válido, renderiza o conteúdo da rota
};

export default ProtectedRoute;
